(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-exploded-map"] && !Shopify.designMode) return;
  try {
    
  class ExplodedMap extends HTMLElement {
    connectedCallback() {
      this.image = this.querySelector('[data-map-image]');
      this.overlay = this.querySelector('[data-map-overlay]');
      this.dialog = this.querySelector('[data-map-dialog]');
      this.panel = this.querySelector('[data-map-panel]');
      this.nav = this.querySelector('[data-map-nav]');
      this.media = this.querySelector('[data-map-media]');
      this.imageShell = this.querySelector('[data-map-image-shell]');
      this.tools = this.querySelector('[data-map-tools]');
      this.parts = this.querySelector('[data-map-parts]');
      this.partsBody = this.querySelector('[data-map-parts-body]');
      this.partsCount = this.querySelector('[data-map-parts-count]');
      this.partsEmpty = this.querySelector('[data-map-parts-empty]');
      this.productCache = new Map();
      this.productIdCache = new Map();
      this.variantProductCache = new Map();
      this.hotspotCache = new Map();
      this.partsData = [];
      this.addedVariants = new Map();
      this.cartVariantQuantities = new Map();
      this.zoom = 1;
      this.minZoom = 1;
      this.maxZoom = 3;
      this.zoomStep = 0.25;
      this.panX = 0;
      this.panY = 0;
      this.activePan = null;
      this.suppressHotspotClickUntil = 0;
      this.currentProduct = null;
      this.currentVariant = null;
      this.currentChoices = [];
      this.railPositionFrame = null;
      this.labels = {
        addToCart: this.dataset.labelAddToCart,
        added: this.dataset.labelAdded,
        quantity: this.dataset.labelQuantity,
        sku: this.dataset.labelSku,
        descriptionMore: this.dataset.labelDescriptionMore,
        descriptionLess: this.dataset.labelDescriptionLess,
        soldOut: this.dataset.labelSoldOut,
        unavailable: this.dataset.labelUnavailable,
        variant: this.dataset.labelVariant,
        loading: this.dataset.labelLoading,
        empty: this.dataset.labelEmpty,
        unavailableMapped: this.dataset.labelUnavailableMapped,
        catalogUnavailable: this.dataset.labelCatalogUnavailable,
        error: this.dataset.labelError,
        nav: this.dataset.labelNav,
        partsList: this.dataset.labelPartsList,
        viewPart: this.dataset.labelViewPart,
        position: this.dataset.labelPosition,
        partno: this.dataset.labelPartno,
        stock: this.dataset.labelStock,
        inStock: this.dataset.labelInStock,
        stockInStock: this.dataset.labelStockInstock,
        stockSupplier: this.dataset.labelStockSupplier,
        stockIncoming: this.dataset.labelStockIncoming,
        stockNotInStock: this.dataset.labelStockNotInStock,
        stockOnRequest: this.dataset.labelStockOnRequest,
        noResults: this.dataset.labelNoResults,
        zoomIn: this.dataset.labelZoomIn,
        zoomOut: this.dataset.labelZoomOut,
        resetView: this.dataset.labelResetView,
        addedParts: this.dataset.labelAddedParts,
        viewCart: this.dataset.labelViewCart,
      };
      this.stockIcons = {
        green: this.dataset.stockGreenIcon,
        yellow: this.dataset.stockYellowIcon,
        red: this.dataset.stockRedIcon,
      };
      this.map = this.readMap();
      this.fallbackNavigation = this.readFallbackNavigation();
      this.readProducts();
      this.readCartVariantQuantities();
      this.panel.addEventListener('click', this.onPanelClick.bind(this));
      this.panel.addEventListener('change', this.onPanelChange.bind(this));
      if (this.tools) this.tools.addEventListener('click', this.onToolsClick.bind(this));
      if (this.image) {
        this.image.addEventListener('load', () => {
          this.applyMapZoom({keepPosition: false});
          this.scheduleRailPosition();
        });
      }
      if (this.imageShell) {
        this.imageShell.addEventListener('mousedown', this.onMapPanStart.bind(this));
        this.imageShell.addEventListener('touchstart', this.onMapPanStart.bind(this), {passive: false});
      }
      document.addEventListener('mousemove', this.onMapPanMove.bind(this));
      document.addEventListener('mouseup', this.onMapPanEnd.bind(this));
      document.addEventListener('touchmove', this.onMapPanMove.bind(this), {passive: false});
      document.addEventListener('touchend', this.onMapPanEnd.bind(this));
      document.addEventListener('touchcancel', this.onMapPanEnd.bind(this));
      window.addEventListener('resize', this.onViewportResize.bind(this));
      window.addEventListener('scroll', this.onWindowScroll.bind(this), {passive: true});
      document.addEventListener('fullscreenchange', () => this.applyMapZoom({keepPosition: false}));
      if (this.parts) {
        this.parts.addEventListener('click', this.onPartsClick.bind(this));
        this.parts.addEventListener('mouseover', this.onPartsPointerOver.bind(this));
        this.parts.addEventListener('mouseout', this.onPartsPointerOut.bind(this));
        this.parts.addEventListener('focusin', this.onPartsFocusIn.bind(this));
        this.parts.addEventListener('focusout', this.onPartsFocusOut.bind(this));
      }
      if (this.dialog) this.dialog.addEventListener('click', this.onDialogClick.bind(this));
      this.render();
      this.renderContextNavigation();
      this.scheduleRailPosition();
    }

    renderContextNavigation() {
      if (!this.nav) return;

      const parentHandle = this.getParentContextHandle();
      const navData = parentHandle ? this.getNavigationForParent(parentHandle) : null;
      const items = navData && Array.isArray(navData.items) ? navData.items.filter((item) => item && item.handle && item.url) : [];

      if (!parentHandle || items.length < 2) {
        this.nav.hidden = true;
        this.nav.innerHTML = '';
        return;
      }

      const currentHandle = this.dataset.collectionHandle || '';
      this.nav.setAttribute('aria-label', this.labels.nav || '');
      this.nav.innerHTML = items.map((item) => {
        const active = item.handle === currentHandle;
        const url = this.withParentContext(item.url, parentHandle, navData.parentId);
        const image = item.image ? `<img src="${this.escapeAttribute(item.image)}" alt="${this.escapeAttribute(item.title)}" loading="lazy">` : `<span class="exploded-map__rail-placeholder">${this.escape((item.title || '?').slice(0, 1))}</span>`;
        return `
          <a class="exploded-map__rail-link${active ? ' is-active' : ''}" href="${this.escapeAttribute(url)}" title="${this.escapeAttribute(item.title)}" ${active ? 'aria-current="page"' : ''}>
            ${image}
            <span class="exploded-map__rail-text">${this.escape(item.title)}</span>
          </a>
        `;
      }).join('');
      this.nav.hidden = false;
      this.scheduleRailPosition();
    }

    getParentContextHandle() {
      const params = new URLSearchParams(window.location.search);
      return params.get('exploded_parent') || (this.fallbackNavigation && this.fallbackNavigation.parentHandle ? this.fallbackNavigation.parentHandle : '');
    }

    getNavigationForParent(parentHandle) {
      const storedNavigation = this.getStoredNavigation(parentHandle);
      if (storedNavigation) return storedNavigation;
      if (this.fallbackNavigation && this.fallbackNavigation.parentHandle === parentHandle) return this.fallbackNavigation;
      return null;
    }

    getStoredNavigation(parentHandle) {
      const key = `radne:exploded-nav:${parentHandle}`;
      const sources = [];

      try {
        sources.push(window.sessionStorage);
      } catch (error) {}

      try {
        sources.push(window.localStorage);
      } catch (error) {}

      for (const source of sources) {
        try {
          const value = source.getItem(key);
          if (!value) continue;
          const data = JSON.parse(value);
          if (data && data.parentHandle === parentHandle) return data;
        } catch (error) {}
      }

      return null;
    }

    readFallbackNavigation() {
      const script = this.querySelector('[data-parent-nav-json]');
      if (!script) return null;

      try {
        const data = JSON.parse(script.textContent.trim() || 'null');
        if (data && data.parentHandle && Array.isArray(data.items)) return data;
      } catch (error) {
        console.warn('Exploded map parent navigation could not be parsed', error);
      }

      return null;
    }

    withParentContext(url, parentHandle, parentId) {
      try {
        const nextUrl = new URL(url, window.location.origin);
        nextUrl.searchParams.set('exploded_parent', parentHandle);
        if (parentId) nextUrl.searchParams.set('exploded_parent_id', parentId);
        return `${nextUrl.pathname}${nextUrl.search}${nextUrl.hash}`;
      } catch (error) {
        return url;
      }
    }

    readMap() {
      const script = this.querySelector('[data-map-json]');
      if (!script) return null;

      try {
        let data = JSON.parse(script.textContent.trim() || 'null');
        if (typeof data === 'string') data = JSON.parse(data);
        if (data && typeof data.value === 'string') data = JSON.parse(data.value);
        if (data && Array.isArray(data.areas)) return data;
      } catch (error) {
        console.warn('Exploded map could not be parsed', error);
      }

      return null;
    }

    readProducts() {
      const script = this.querySelector('[data-products-json]');
      if (!script) return;

      try {
        const products = JSON.parse(script.textContent.trim() || '{}');
        Object.keys(products).forEach((handle) => {
          const product = products[handle];
          const productId = this.idFromGid(product && product.id);
          this.productCache.set(this.cleanProductHandle(handle), product);
          if (productId) this.productIdCache.set(String(productId), product);
          if (product && Array.isArray(product.variants)) {
            product.variants.forEach((variant) => {
              const variantId = this.idFromGid(variant && variant.id);
              if (variantId) this.variantProductCache.set(String(variantId), product);
            });
          }
        });
      } catch (error) {
        console.warn('Exploded map products could not be parsed', error);
      }
    }

    readCartVariantQuantities() {
      const script = this.querySelector('[data-cart-variants-json]');
      if (!script) return;

      try {
        const items = JSON.parse(script.textContent.trim() || '[]');
        if (!Array.isArray(items)) return;

        items.forEach((item) => {
          const variantId = item && item.variant_id ? String(item.variant_id) : '';
          const quantity = this.numberValue(item && item.quantity);
          if (!variantId || quantity < 1) return;
          this.cartVariantQuantities.set(variantId, (this.cartVariantQuantities.get(variantId) || 0) + quantity);
        });
      } catch (error) {
        console.warn('Exploded map cart variants could not be parsed', error);
      }
    }

    syncAddedVariantsFromCartRows(rows) {
      if (!this.cartVariantQuantities || !this.cartVariantQuantities.size || !Array.isArray(rows)) return;

      rows.forEach((row) => {
        const variantId = row && row.variant && row.variant.id ? String(row.variant.id) : '';
        const quantity = variantId ? this.cartVariantQuantities.get(variantId) || 0 : 0;
        if (quantity > 0) this.addedVariants.set(variantId, quantity);
      });
    }

    render() {
      if (!this.map || !this.map.imageUrl) {
        this.panel.innerHTML = `<div class="exploded-map__panel-empty">${this.escape(this.labels.empty)}</div>`;
        return;
      }

      this.image.src = this.map.imageUrl;
      this.image.alt = this.dataset.imageAlt || '';
      if (this.image.complete) this.applyMapZoom({keepPosition: false});
      this.overlay.innerHTML = '';
      this.hotspotCache.clear();
      this.map.areas.forEach((area, index) => {
        const hotspot = this.createHotspot(area, index);
        if (hotspot) {
          this.overlay.appendChild(hotspot);
          this.hotspotCache.set(this.areaKey(area, index), hotspot);
        }
      });
      this.renderPartsList();
    }

    createHotspot(area, index) {
      if (!area || !Array.isArray(area.points) || !area.points.length) return null;

      const namespace = 'http://www.w3.org/2000/svg';
      const group = document.createElementNS(namespace, 'g');
      const title = area.label || area.productTitle || area.callout || String(index + 1);
      const point = this.getLabelPoint(area);
      const searchText = this.areaSearchText(area, index);

      group.classList.add('exploded-map__hotspot');
      group.setAttribute('role', 'button');
      group.setAttribute('tabindex', '0');
      group.setAttribute('aria-label', title);
      group.setAttribute('title', title);
      group.setAttribute('data-map-area-key', this.areaKey(area, index));
      group.setAttribute('data-map-search-text', searchText);

      const nativeTitle = document.createElementNS(namespace, 'title');
      nativeTitle.textContent = title;
      group.appendChild(nativeTitle);

      if (area.shape === 'polygon' && area.points.length > 2) {
        const polygon = document.createElementNS(namespace, 'polygon');
        polygon.classList.add('exploded-map__polygon');
        polygon.setAttribute('points', area.points.map((item) => `${this.cleanNumber(item.x)},${this.cleanNumber(item.y)}`).join(' '));
        group.appendChild(polygon);
      } else {
        const ring = document.createElementNS(namespace, 'circle');
        ring.classList.add('exploded-map__ring');
        ring.setAttribute('cx', this.cleanNumber(point.x));
        ring.setAttribute('cy', this.cleanNumber(point.y));
        ring.setAttribute('r', '2.35');
        group.appendChild(ring);

        const circle = document.createElementNS(namespace, 'circle');
        circle.classList.add('exploded-map__circle');
        circle.setAttribute('cx', this.cleanNumber(point.x));
        circle.setAttribute('cy', this.cleanNumber(point.y));
        circle.setAttribute('r', '1.95');
        group.appendChild(circle);
      }

      group.addEventListener('click', (event) => {
        if (this.consumeSuppressedHotspotClick(event)) return;
        this.selectArea(area, group);
      });
      group.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          this.selectArea(area, group);
        }
      });

      return group;
    }

    getLabelPoint(area) {
      const points = area.points.map((point) => ({x: Number(point.x) || 0, y: Number(point.y) || 0}));
      if (area.shape !== 'polygon' || points.length < 3) return points[0];
      const total = points.reduce((sum, point) => ({x: sum.x + point.x, y: sum.y + point.y}), {x: 0, y: 0});
      return {x: total.x / points.length, y: total.y / points.length};
    }

    cleanNumber(value) {
      const number = Number(value);
      return Number.isFinite(number) ? String(Math.max(0, Math.min(100, number))) : '0';
    }

    areaKey(area, index) {
      return area && area.id ? String(area.id) : `area-${index}`;
    }

    areaSearchText(area, index) {
      const refs = this.getAreaProductRefs(area);
      const values = [
        area && area.callout,
        area && area.label,
        area && area.productTitle,
        String(index + 1),
      ];

      refs.forEach((ref) => {
        values.push(ref.label, ref.productTitle, ref.productHandle, ref.variantTitle);
      });

      return this.normalizeSearch(values.filter(Boolean).join(' '));
    }

    renderPartsList() {
      if (!this.map || !Array.isArray(this.map.areas) || !this.parts || !this.partsBody) return;

      const rows = [];
      this.map.areas.forEach((area, areaIndex) => {
        const refs = this.getAreaProductRefs(area);
        const areaKey = this.areaKey(area, areaIndex);
        refs.forEach((ref, refIndex) => {
          const product = this.getCachedProduct(this.cleanProductHandle(ref.productHandle), ref.productId, ref.variantId);
          const variant = product ? this.getInitialVariant(product, ref.variantId) : null;
          const title = product && product.title ? product.title : ref.label || ref.productTitle || area.label || area.productTitle || this.labels.unavailable;
          const callout = ref.callout || area.callout || String(areaIndex + 1);
          const sku = variant && variant.sku ? variant.sku : product && product.sku ? product.sku : '';
          const mpn = variant && variant.mpn ? variant.mpn : '';
          const searchText = this.normalizeSearch([callout, title, sku, mpn, ref.productHandle, ref.variantTitle].filter(Boolean).join(' '));

          rows.push({
            area: area,
            areaKey: areaKey,
            callout: callout,
            ref: ref,
            product: product,
            variant: variant,
            title: title,
            sku: sku,
            mpn: mpn,
            catalogUnavailable: false,
            searchText: searchText,
            rowKey: `${areaKey}-${refIndex}`,
          });
        });
      });

      this.partsData = rows;
      this.syncAddedVariantsFromCartRows(rows);

      if (!rows.length) {
        this.parts.hidden = true;
        if (this.tools) this.tools.hidden = true;
        return;
      }

      if (this.partsCount) {
        this.partsCount.textContent = `${rows.length} ${this.labels.partsList.toLowerCase()}`;
      }

      const serverRows = Array.from(this.partsBody.querySelectorAll('[data-map-part-row]'));
      if (serverRows.length) {
        serverRows.forEach((rowElement, index) => {
          const row = rows[index];
          const openButton = rowElement.querySelector('[data-map-part-open]');
          const addButton = rowElement.querySelector('[data-map-part-add]');
          const quantityInput = rowElement.querySelector('[data-map-part-quantity]');

          rowElement.dataset.mapPartRow = String(index);
          if (openButton) openButton.dataset.mapPartOpen = String(index);
          if (addButton) addButton.dataset.mapPartAdd = String(index);
          if (quantityInput) quantityInput.dataset.mapPartQuantity = String(index);

          if (row) {
            rowElement.dataset.mapAreaKey = row.areaKey;
            rowElement.dataset.mapSearchText = row.searchText;
            row.catalogUnavailable = this.isCatalogUnavailable(row.variant);
            rowElement.dataset.mapCatalogUnavailable = row.catalogUnavailable ? 'true' : 'false';
            if (row.variant && row.variant.id) {
              rowElement.dataset.mapVariantId = String(row.variant.id);
            }
            this.hydrateServerPartRow(rowElement, row);
          }
        });
      }
      this.parts.hidden = false;
      if (this.tools) this.tools.hidden = false;
      this.applySearchFilter();
      this.updateAddedState();
    }

    hydrateServerPartRow(rowElement, row) {
      if (!rowElement || !row) return;

      const product = row.product || {};
      const variant = row.variant || null;
      const title = row.title || this.labels.unavailable;
      const imageUrl = this.getProductImage(product, variant);
      const status = this.getStockStatus(variant);
      const canAdd = this.canAddVariant(variant);
      const addButtonLabel = canAdd ? this.labels.addToCart : (this.isCatalogUnavailable(variant) ? this.labels.catalogUnavailable : this.labels.soldOut);

      const nameButton = rowElement.querySelector('[data-map-part-open]');
      if (nameButton) {
        nameButton.textContent = title;
        nameButton.setAttribute('aria-label', `${this.labels.viewPart}: ${title}`);
      }

      const imageCell = rowElement.querySelector('.exploded-map__parts-image');
      if (imageCell) {
        imageCell.innerHTML = imageUrl
          ? `<img src="${this.escapeAttribute(imageUrl)}" alt="${this.escapeAttribute(title)}" width="120" loading="lazy">`
          : '';
      }

      const productContent = rowElement.querySelector('.exploded-map__parts-product > span:last-child');
      let price = rowElement.querySelector('.exploded-map__parts-meta');
      if (variant) {
        if (!price && productContent) {
          price = document.createElement('div');
          price.className = 'exploded-map__parts-meta';
          productContent.appendChild(price);
        }
        if (price) price.textContent = this.formatMoney(variant.price);
      } else if (price) {
        price.remove();
      }

      const skuCell = rowElement.querySelector('.exploded-map__parts-sku');
      if (skuCell) skuCell.innerHTML = row.sku ? `<span>${this.escape(row.sku)}</span>` : '-';

      const mpnCell = rowElement.querySelector('.exploded-map__parts-mpn');
      if (mpnCell) mpnCell.innerHTML = row.mpn ? `<span>${this.escape(row.mpn)}</span>` : '-';

      const stockCell = rowElement.querySelector('.exploded-map__parts-stock');
      if (stockCell) stockCell.innerHTML = this.renderStockStatus(status);

      const addButton = rowElement.querySelector('[data-map-part-add]');
      if (addButton) {
        addButton.disabled = !canAdd;
        addButton.setAttribute('aria-label', addButtonLabel || '');
        addButton.setAttribute('title', addButtonLabel || '');
        const addText = addButton.querySelector('[data-map-part-add-text]');
        if (addText) addText.textContent = addButtonLabel || '';
      }

      this.updateQuantityInputLimit(rowElement.querySelector('[data-map-part-quantity]'), variant);
    }

    onToolsClick(event) {
      const zoomIn = event.target.closest('[data-map-zoom-in]');
      const zoomOut = event.target.closest('[data-map-zoom-out]');
      const reset = event.target.closest('[data-map-reset-view]');

      if (zoomIn) {
        event.preventDefault();
        this.setMapZoom(this.zoom + this.zoomStep);
      }

      if (zoomOut) {
        event.preventDefault();
        this.setMapZoom(this.zoom - this.zoomStep);
      }

      if (reset) {
        event.preventDefault();
        this.resetMapView();
      }
    }

    onViewportResize() {
      window.clearTimeout(this.resizeTimer);
      this.resizeTimer = window.setTimeout(() => {
        this.applyMapZoom({keepPosition: false});
        this.scheduleRailPosition();
      }, 120);
    }

    onWindowScroll() {
      this.scheduleRailPosition();
    }

    scheduleRailPosition() {
      if (!this.nav || !this.imageShell || this.nav.hidden) return;
      window.cancelAnimationFrame(this.railPositionFrame);
      this.railPositionFrame = window.requestAnimationFrame(() => this.updateRailPosition());
    }

    updateRailPosition() {
      if (!this.nav || !this.imageShell || this.nav.hidden) return;

      if (window.matchMedia('(max-width: 989px)').matches) {
        this.nav.style.removeProperty('--exploded-rail-top');
        this.nav.style.removeProperty('--exploded-rail-max-height');
        return;
      }

      const rect = this.imageShell.getBoundingClientRect();
      const top = Math.max(12, Math.round(rect.top));
      const maxHeight = Math.max(160, Math.round(window.innerHeight - top - 16));
      this.nav.style.setProperty('--exploded-rail-top', `${top}px`);
      this.nav.style.setProperty('--exploded-rail-max-height', `${maxHeight}px`);
    }

    setMapZoom(value) {
      this.zoom = Math.max(this.minZoom, Math.min(this.maxZoom, Number(value) || this.minZoom));
      this.applyMapZoom({keepPosition: true});
    }

    resetMapView() {
      this.zoom = 1;
      this.panX = 0;
      this.panY = 0;
      this.applyMapZoom({keepPosition: false});
      if (this.media) {
        this.media.scrollLeft = 0;
        this.media.scrollTop = 0;
      }
    }

    applyMapZoom(options = {}) {
      if (!this.media || !this.imageShell || !this.image) return;

      const baseWidth = this.getBaseMapWidth();

      this.imageShell.style.width = `${Math.round(baseWidth)}px`;
      this.imageShell.style.marginLeft = '';
      if (this.zoom <= this.minZoom) {
        this.panX = 0;
        this.panY = 0;
      }
      this.imageShell.style.setProperty('--exploded-map-zoom', String(this.zoom));
      this.imageShell.style.setProperty('--exploded-map-pan-x', `${Math.round(this.panX)}px`);
      this.imageShell.style.setProperty('--exploded-map-pan-y', `${Math.round(this.panY)}px`);
      this.imageShell.classList.toggle('is-zoomed', this.zoom > 1);

      this.updateMapZoomControls();
    }

    onMapPanStart(event) {
      if (!this.imageShell || this.zoom <= this.minZoom) return;
      if (event.type === 'mousedown' && event.button !== 0) return;
      if (event.touches && event.touches.length > 1) return;
      if (event.target.closest && event.target.closest('.exploded-map__tools')) return;
      if (event.target.closest && event.target.closest('.exploded-map__hotspot')) return;
      if (event.target.closest && event.target.closest('a, button, input, select, textarea')) return;

      const point = this.getPanEventPoint(event);
      if (!point) return;

      event.preventDefault();
      this.activePan = {
        startX: point.x,
        startY: point.y,
        panX: this.panX,
        panY: this.panY,
        moved: false,
      };
    }

    onMapPanMove(event) {
      if (!this.activePan) return;

      const point = this.getPanEventPoint(event);
      if (!point) return;

      const deltaX = point.x - this.activePan.startX;
      const deltaY = point.y - this.activePan.startY;
      if (Math.abs(deltaX) > 3 || Math.abs(deltaY) > 3) {
        this.activePan.moved = true;
      }
      if (!this.activePan.moved) return;

      event.preventDefault();
      if (this.imageShell) this.imageShell.classList.add('is-panning');
      this.setMapPan(this.activePan.panX + deltaX, this.activePan.panY + deltaY);
    }

    onMapPanEnd() {
      if (!this.activePan) return;

      if (this.activePan.moved) {
        this.suppressHotspotClickUntil = Date.now() + 100;
      }
      if (this.imageShell) this.imageShell.classList.remove('is-panning');
      this.activePan = null;
    }

    getPanEventPoint(event) {
      const touch = event.touches && event.touches.length ? event.touches[0] : event.changedTouches && event.changedTouches.length ? event.changedTouches[0] : null;
      if (touch) return {x: touch.clientX, y: touch.clientY};
      if (typeof event.clientX === 'number' && typeof event.clientY === 'number') return {x: event.clientX, y: event.clientY};
      return null;
    }

    consumeSuppressedHotspotClick(event) {
      if (Date.now() >= this.suppressHotspotClickUntil) return false;
      event.preventDefault();
      event.stopPropagation();
      return true;
    }

    setMapPan(x, y) {
      if (!this.imageShell || this.zoom <= this.minZoom) {
        this.panX = 0;
        this.panY = 0;
      } else {
        this.panX = Number(x) || 0;
        this.panY = Number(y) || 0;
      }

      this.imageShell.style.setProperty('--exploded-map-pan-x', `${Math.round(this.panX)}px`);
      this.imageShell.style.setProperty('--exploded-map-pan-y', `${Math.round(this.panY)}px`);
    }

    getBaseMapWidth() {
      if (!this.media || !this.image) return 0;

      const mediaWidth = this.media.clientWidth || this.image.clientWidth || 0;
      const naturalWidth = this.image.naturalWidth || mediaWidth;
      const naturalHeight = this.image.naturalHeight || this.image.clientHeight || 1;
      const ratio = naturalHeight > 0 ? naturalWidth / naturalHeight : 1;

      let baseWidth = Math.min(naturalWidth, mediaWidth || naturalWidth);
      const fullscreenElement = document.fullscreenElement;
      const isFullscreen = fullscreenElement && fullscreenElement.contains(this);
      const maxHeight = isFullscreen
        ? Math.max(360, window.innerHeight - 112)
        : window.innerWidth >= 990
          ? Math.max(360, window.innerHeight - 180)
          : Infinity;

      if (Number.isFinite(maxHeight)) {
        baseWidth = Math.min(baseWidth, maxHeight * ratio);
      }

      return Math.max(260, baseWidth);
    }

    updateMapZoomControls() {
      const zoomOut = this.querySelector('[data-map-zoom-out]');
      const zoomIn = this.querySelector('[data-map-zoom-in]');
      const reset = this.querySelector('[data-map-reset-view]');
      if (zoomOut) zoomOut.disabled = this.zoom <= this.minZoom;
      if (zoomIn) zoomIn.disabled = this.zoom >= this.maxZoom;
      if (reset) reset.disabled = this.zoom === 1;
    }

    applySearchFilter() {
      const query = this.normalizeSearch(this.searchInput ? this.searchInput.value : '');
      const rows = Array.from(this.querySelectorAll('[data-map-part-row]'));
      const matchingAreaKeys = new Set();
      let visibleRows = 0;

      rows.forEach((row) => {
        const matches = !query || this.normalizeSearch(row.dataset.mapSearchText || '').includes(query);
        row.classList.toggle('is-hidden', !matches);
        if (matches) {
          visibleRows += 1;
          matchingAreaKeys.add(row.dataset.mapAreaKey);
        }
      });

      this.querySelectorAll('.exploded-map__hotspot').forEach((hotspot) => {
        const matches = matchingAreaKeys.has(hotspot.getAttribute('data-map-area-key'));
        hotspot.classList.toggle('is-search-match', Boolean(query && matches));
        hotspot.classList.toggle('is-search-muted', Boolean(query && !matches));
      });

      if (this.clearSearch) this.clearSearch.hidden = !query;
      if (this.partsEmpty) this.partsEmpty.hidden = !query || visibleRows > 0;
      if (this.partsCount) {
        const total = this.partsData.length;
        this.partsCount.textContent = query ? `${visibleRows} / ${total} ${this.labels.partsList.toLowerCase()}` : `${total} ${this.labels.partsList.toLowerCase()}`;
      }
    }

    normalizeSearch(value) {
      return String(value || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim();
    }

    selectArea(area, hotspot) {
      this.querySelectorAll('.exploded-map__hotspot.is-active').forEach((item) => item.classList.remove('is-active'));
      hotspot.classList.add('is-active');
      this.currentProduct = null;
      this.currentVariant = null;
      this.currentChoices = [];
      this.panel.innerHTML = `<div class="exploded-map__panel-loading">${this.escape(this.labels.loading)}</div>`;
      this.openDialog();

      const productRefs = this.getAreaProductRefs(area);

      if (!productRefs.length) {
        this.renderAreaOnly(area);
        return;
      }

      if (productRefs.length > 1) {
        this.getProductChoices(productRefs)
          .then((choices) => this.renderProductChoices(area, choices))
          .catch((error) => {
            console.warn('Exploded map product choices failed', {area: area, error: error});
            this.renderUnavailableArea(area);
          });
        return;
      }

      this.loadProductRef(productRefs[0])
        .then((product) => {
          this.showProduct(productRefs[0], product);
        })
        .catch((error) => {
          console.warn('Exploded map product lookup failed', {
            productHandle: productRefs[0].productHandle,
            productId: productRefs[0].productId,
            variantId: productRefs[0].variantId,
            area: area,
            error: error,
          });
          this.renderUnavailableArea(productRefs[0]);
        });
    }

    getAreaProductRefs(area) {
      const productList = Array.isArray(area && area.links) ? area.links : Array.isArray(area && area.products) ? area.products : Array.isArray(area && area.items) ? area.items : Array.isArray(area && area.productRefs) ? area.productRefs : [];
      if (productList.length) {
        return productList.map((item) => this.normalizeProductRef(item, area)).filter((item) => this.hasProductRef(item));
      }

      const directRef = this.normalizeProductRef(area, area);
      return this.hasProductRef(directRef) ? [directRef] : [];
    }

    normalizeProductRef(item, area) {
      area = area || {};
      const ref = typeof item === 'string' ? {productHandle: item} : Object.assign({}, item || {});
      ref.callout = ref.callout || area.callout;
      ref.label = ref.label || ref.productTitle || area.label || area.productTitle || area.callout;
      ref.productTitle = ref.productTitle || ref.label;
      ref.productHandle = ref.productHandle || ref.handle || ref.product_handle || ref.url;
      ref.productId = ref.productId || ref.product_id;
      ref.variantId = ref.variantId || ref.variant_id;
      ref.variantTitle = ref.variantTitle || ref.variant_title;
      return ref;
    }

    hasProductRef(ref) {
      return Boolean(ref && (ref.productHandle || ref.productId || ref.variantId));
    }

    getProductChoices(productRefs) {
      return Promise.all(productRefs.map((ref) => {
        return this.loadProductRef(ref)
          .then((product) => ({ref: ref, product: product, error: null}))
          .catch((error) => ({ref: ref, product: null, error: error}));
      }));
    }

    loadProductRef(ref) {
      return this.getProduct(ref);
    }

    showProduct(ref, product) {
      this.currentProduct = product;
      this.currentVariant = this.getInitialVariant(product, ref.variantId);
      this.renderProduct(ref, product);
    }

    renderProductChoices(area, choices) {
      this.currentChoices = choices;
      const title = area.label || area.productTitle || area.callout || this.labels.empty;
      const items = choices.map((choice, index) => this.renderProductChoice(choice, index)).join('');

      this.panel.innerHTML = `
        <div class="exploded-map__choices">
          <h3 class="exploded-map__choices-title">${this.escape(title)}</h3>
          <div class="exploded-map__choices-list">
            ${items}
          </div>
        </div>
      `;
    }

    renderProductChoice(choice, index) {
      const product = choice.product;
      const ref = choice.ref || {};
      const title = product && product.title ? product.title : ref.label || ref.productTitle || this.labels.unavailable;
      const image = product ? this.getProductImage(product, this.getInitialVariant(product, ref.variantId)) : '';
      const media = image
        ? `<img src="${this.escapeAttribute(image)}" alt="${this.escapeAttribute(title)}" loading="lazy">`
        : `<span class="exploded-map__choice-placeholder">${this.escape(this.labels.unavailable)}</span>`;

      return `
        <button class="exploded-map__choice" type="button" data-map-product-choice="${index}">
          <span class="exploded-map__choice-media">${media}</span>
          <span class="exploded-map__choice-title">${this.escape(title)}</span>
        </button>
      `;
    }

    selectProductChoice(index) {
      const choice = this.currentChoices[Number(index)];
      if (!choice) return;

      if (!choice.product) {
        this.renderUnavailableArea(choice.ref || {});
        return;
      }

      this.showProduct(choice.ref, choice.product);
    }

    getProduct(area) {
      const handle = this.cleanProductHandle(area && area.productHandle);
      const cachedProduct = this.getCachedProduct(handle, area && area.productId, area && area.variantId);
      if (cachedProduct) return Promise.resolve(cachedProduct);
      if (!handle) return this.getVariantProduct(area);

      const root = window.theme && window.theme.routes && window.theme.routes.root ? window.theme.routes.root : '/';
      const encodedHandle = encodeURIComponent(handle);
      const urls = [
        `${root}products/${encodedHandle}.js`,
        `/products/${encodedHandle}.js`,
        `${root}products/${encodedHandle}.json`,
        `/products/${encodedHandle}.json`,
      ];

      return this.fetchFirstProductUrl(urls)
        .then((product) => {
          const normalizedProduct = this.normalizeProductData(product);
          if (!normalizedProduct) throw new Error('Product data could not be normalized');
          this.productCache.set(handle, normalizedProduct);
          return normalizedProduct;
        })
        .catch((error) => {
          return this.getVariantProduct(area).catch(() => {
            throw error;
          });
        });
    }

    getVariantProduct(area) {
      const variantId = this.idFromGid(area && area.variantId);
      if (!variantId) return Promise.reject(new Error('Missing variant id'));

      const root = window.theme && window.theme.routes && window.theme.routes.root ? window.theme.routes.root : '/';
      const urls = [`${root}variants/${variantId}.js`, `/variants/${variantId}.js`];
      return this.fetchFirstProductUrl(urls).then((data) => this.productFromVariantData(area, data));
    }

    normalizeProductData(data) {
      const product = data && data.product ? data.product : data;
      if (!product || !Array.isArray(product.variants)) return null;
      product.handle = this.cleanProductHandle(product.handle || product.url);
      product.url = product.url || (product.handle ? `/products/${product.handle}` : '');
      product.sku = product.sku || '';
      product.description = this.stripHtml(product.description || product.body_html || '');
      product.featured_image = this.imageSource(product.featured_image);
      product.images = Array.isArray(product.images) ? product.images.map((image) => this.imageSource(image)).filter(Boolean) : [];
      product.variants = product.variants.map((variant) => this.normalizeVariantData(variant));
      return product;
    }

    productFromVariantData(area, data) {
      const variantData = data && data.variant ? data.variant : data;
      const variant = this.normalizeVariantData(variantData, area);
      const handle = this.cleanProductHandle(area && area.productHandle);
      const image = this.imageSource(variant.featured_image || variantData.featured_image || variantData.image);
      return {
        id: this.idFromGid(area && area.productId) || variantData.product_id || '',
        handle: handle,
        title: area.productTitle || area.label || variantData.product_title || variantData.name || variant.title || this.labels.unavailable,
        url: handle ? `/products/${handle}` : '',
        available: variant.available,
        sku: area.sku || '',
        featured_image: image,
        images: image ? [image] : [],
        variants: [variant],
      };
    }

    normalizeVariantData(variant, area) {
      const fallbackId = this.idFromGid(area && area.variantId);
      return {
        id: this.idFromGid(variant && variant.id) || fallbackId || (variant && variant.id),
        title: variant && variant.title ? variant.title : area && area.variantTitle ? area.variantTitle : 'Default Title',
        public_title: variant && (variant.public_title || variant.title) ? (variant.public_title || variant.title) : area && area.variantTitle ? area.variantTitle : 'Default Title',
        available: variant && typeof variant.available !== 'undefined' ? variant.available : true,
        price: variant && typeof variant.price !== 'undefined' ? variant.price : '',
        sku: variant && variant.sku ? variant.sku : '',
        mpn: variant && variant.mpn ? variant.mpn : '',
        inventory_policy: variant && variant.inventory_policy ? variant.inventory_policy : '',
        inventory_management: variant && variant.inventory_management ? variant.inventory_management : '',
        inventory_quantity: variant && typeof variant.inventory_quantity !== 'undefined' ? variant.inventory_quantity : null,
        radne_stock_level: variant && typeof variant.radne_stock_level !== 'undefined' ? variant.radne_stock_level : null,
        supplier_stock_level: variant && typeof variant.supplier_stock_level !== 'undefined' ? variant.supplier_stock_level : null,
        incoming_quantity: variant && typeof variant.incoming_quantity !== 'undefined' ? variant.incoming_quantity : null,
        back_in_stock_date: variant && variant.back_in_stock_date ? variant.back_in_stock_date : '',
        featured_image: {src: this.imageSource(variant && (variant.featured_image || variant.image))},
      };
    }

    imageSource(image) {
      if (!image) return '';
      if (typeof image === 'string') return image;
      return image.src || image.url || '';
    }

    getCachedProduct(handle, productId, variantId) {
      const numericProductId = this.idFromGid(productId);
      const numericVariantId = this.idFromGid(variantId);
      if (handle && this.productCache.has(handle)) return this.productCache.get(handle);
      if (numericProductId && this.productIdCache.has(String(numericProductId))) return this.productIdCache.get(String(numericProductId));
      if (numericVariantId && this.variantProductCache.has(String(numericVariantId))) return this.variantProductCache.get(String(numericVariantId));
      return null;
    }

    fetchFirstProductUrl(urls) {
      const [url, ...rest] = urls;

      return fetch(url)
        .then((response) => {
          if (!response.ok) throw new Error(`Product request failed: ${url}`);
          return response.json();
        })
        .catch((error) => {
          if (!rest.length) throw error;
          return this.fetchFirstProductUrl(rest);
        });
    }

    getInitialVariant(product, variantId) {
      const numericVariantId = this.idFromGid(variantId);
      const variants = Array.isArray(product.variants) ? product.variants : [];
      if (numericVariantId) {
        const requested = variants.find((variant) => Number(variant.id) === numericVariantId);
        if (requested) return requested;
      }
      return variants.find((variant) => variant.available) || variants[0] || null;
    }

    idFromGid(value) {
      if (!value) return null;
      const parts = String(value).split('/');
      const number = Number(parts[parts.length - 1]);
      return Number.isFinite(number) ? number : null;
    }

    cleanProductHandle(value) {
      let handle = String(value || '').trim();
      if (!handle) return '';
      if (handle.indexOf('/products/') !== -1) handle = handle.split('/products/').pop();
      return handle.split('?')[0].split('#')[0].replace(/^\/+|\/+$/g, '');
    }

    renderAreaOnly(area) {
      this.panel.innerHTML = `
        <div class="exploded-map__product">
          <h3 class="exploded-map__product-title">${this.escape(area.label || area.productTitle || this.labels.unavailable)}</h3>
        </div>
      `;
    }

    renderUnavailableArea(area) {
      const message = this.isCatalogUnavailableRef(area) ? this.labels.catalogUnavailable : this.labels.unavailableMapped;
      this.panel.innerHTML = `
        <div class="exploded-map__product">
          <h3 class="exploded-map__product-title">${this.escape(area.label || area.productTitle || this.labels.unavailable)}</h3>
          <div class="exploded-map__panel-error">${this.escape(message)}</div>
        </div>
      `;
    }

    openDialog() {
      if (!this.dialog) return;
      this.positionDialogInViewport();
      if (typeof this.dialog.showModal === 'function') {
        if (!this.dialog.open) this.dialog.showModal();
      } else {
        this.dialog.setAttribute('open', '');
      }
    }

    positionDialogInViewport() {
      if (!this.dialog || !window.visualViewport || window.visualViewport.scale <= 1.05) {
        this.clearDialogViewportPosition();
        return;
      }

      const viewport = window.visualViewport;
      const scale = viewport.scale || 1;
      this.dialog.classList.add('is-viewport-positioned');
      this.dialog.style.setProperty('--exploded-dialog-left', `${viewport.offsetLeft + viewport.width / 2}px`);
      this.dialog.style.setProperty('--exploded-dialog-top', `${viewport.offsetTop + viewport.height / 2}px`);
      this.dialog.style.setProperty('--exploded-dialog-width', `${viewport.width * scale}px`);
      this.dialog.style.setProperty('--exploded-dialog-height', `${viewport.height * scale}px`);
      this.dialog.style.setProperty('--exploded-dialog-scale', String(1 / scale));
    }

    clearDialogViewportPosition() {
      if (!this.dialog) return;
      this.dialog.classList.remove('is-viewport-positioned');
      this.dialog.style.removeProperty('--exploded-dialog-left');
      this.dialog.style.removeProperty('--exploded-dialog-top');
      this.dialog.style.removeProperty('--exploded-dialog-width');
      this.dialog.style.removeProperty('--exploded-dialog-height');
      this.dialog.style.removeProperty('--exploded-dialog-scale');
    }

    closeDialog() {
      if (!this.dialog) return;
      if (typeof this.dialog.close === 'function') {
        this.dialog.close();
      } else {
        this.dialog.removeAttribute('open');
      }
      this.clearDialogViewportPosition();
    }

    renderProduct(area, product) {
      const variant = this.currentVariant;
      const variants = Array.isArray(product.variants) ? product.variants : [];
      const image = this.getProductImage(product, variant);
      const canAdd = this.canAddVariant(variant);
      const remainingQuantity = this.remainingQuantityForVariant(variant);
      const quantityMaxAttribute = remainingQuantity === null ? '' : ` max="${this.escapeAttribute(String(remainingQuantity))}"`;
      const stock = this.getStockStatus(variant);
      const sku = variant && variant.sku ? variant.sku : product && product.sku ? product.sku : '';
      const unavailableButtonText = this.isCatalogUnavailable(variant) ? this.labels.catalogUnavailable : this.labels.soldOut;

      this.panel.innerHTML = `
        <div class="exploded-map__product">
          ${image ? `<a class="exploded-map__product-media" href="${this.escapeAttribute(product.url)}"><img src="${this.escapeAttribute(image)}" alt="${this.escapeAttribute(product.title)}" loading="lazy"></a>` : ''}
          <div class="exploded-map__product-info">
            <h3 class="exploded-map__product-title"><a href="${this.escapeAttribute(product.url)}">${this.escape(product.title)}</a></h3>
            <div class="exploded-map__price" data-map-price>${variant ? this.formatMoney(variant.price) : ''}</div>
            <div class="exploded-map__sku" data-map-sku ${sku ? '' : 'hidden'}>${this.renderSku(sku)}</div>
            <div class="exploded-map__mpn" data-map-mpn ${variant && variant.mpn ? '' : 'hidden'}>${this.renderMpn(variant)}</div>
            <div class="exploded-map__product-stock" data-map-stock>${this.renderStockStatus(stock)}</div>
          </div>
          ${this.renderDescription(product)}
          ${variants.length > 1 ? this.renderVariantSelect(variants, variant) : ''}
          <div class="exploded-map__actions">
            <div class="exploded-map__quantity">
              <label class="exploded-map__quantity-label" for="ExplodedMapQuantity">${this.escape(this.labels.quantity)}</label>
              <div class="exploded-map__quantity-control">
                <button type="button" data-map-decrease aria-label="${this.escapeAttribute(this.labels.quantity)}">-</button>
                <input id="ExplodedMapQuantity" type="number" min="1"${quantityMaxAttribute} value="1" inputmode="numeric" data-map-quantity>
                <button type="button" data-map-increase aria-label="${this.escapeAttribute(this.labels.quantity)}">+</button>
              </div>
            </div>
            <button class="exploded-map__add btn btn--medium btn--solid btn--primary" type="button" data-map-add ${canAdd ? '' : 'disabled'}>
              <span class="btn__text" data-map-add-text>${this.escape(canAdd ? this.labels.addToCart : unavailableButtonText)}</span>
              <span class="btn__added">&nbsp;</span>
              <span class="btn__loader">
                <svg height="18" width="18" class="svg-loader">
                  <circle r="7" cx="9" cy="9"></circle>
                  <circle stroke-dasharray="87.96459430051421 87.96459430051421" r="7" cx="9" cy="9"></circle>
                </svg>
              </span>
            </button>
          </div>
          <div class="exploded-map__status" data-map-status></div>
        </div>
      `;
    }

    renderVariantSelect(variants, selectedVariant) {
      const options = variants.map((variant) => {
        const selected = selectedVariant && Number(selectedVariant.id) === Number(variant.id) ? ' selected' : '';
        const disabled = variant.available ? '' : ' disabled';
        const title = variant.public_title || variant.title;
        return `<option value="${this.escapeAttribute(String(variant.id))}"${selected}${disabled}>${this.escape(title)}</option>`;
      }).join('');

      return `
        <div class="exploded-map__variant">
          <label for="ExplodedMapVariant">${this.escape(this.labels.variant)}</label>
          <select id="ExplodedMapVariant" data-map-variant>${options}</select>
        </div>
      `;
    }

    onPanelChange(event) {
      if (!event.target.matches('[data-map-variant]') || !this.currentProduct) return;
      const variantId = Number(event.target.value);
      const variant = this.currentProduct.variants.find((item) => Number(item.id) === variantId);
      if (!variant) return;

      this.currentVariant = variant;
      const image = this.panel.querySelector('.exploded-map__product-media img');
      const price = this.panel.querySelector('[data-map-price]');
      const sku = this.panel.querySelector('[data-map-sku]');
      const mpn = this.panel.querySelector('[data-map-mpn]');
      const stock = this.panel.querySelector('[data-map-stock]');
      const add = this.panel.querySelector('[data-map-add]');
      const addText = this.panel.querySelector('[data-map-add-text]');
      const quantityInput = this.panel.querySelector('[data-map-quantity]');
      const imageUrl = this.getProductImage(this.currentProduct, variant);
      if (image && imageUrl) image.src = imageUrl;
      if (price) price.textContent = this.formatMoney(variant.price);
      if (sku) {
        const skuValue = variant.sku || this.currentProduct.sku || '';
        sku.hidden = !skuValue;
        sku.innerHTML = this.renderSku(skuValue);
      }
      if (mpn) {
        mpn.hidden = !variant.mpn;
        mpn.innerHTML = this.renderMpn(variant);
      }
      if (stock) stock.innerHTML = this.renderStockStatus(this.getStockStatus(variant));
      if (add && addText) {
        const canAdd = this.canAddVariant(variant);
        add.disabled = !canAdd;
        addText.textContent = canAdd ? this.labels.addToCart : this.isCatalogUnavailable(variant) ? this.labels.catalogUnavailable : this.labels.soldOut;
      }
      this.updateQuantityInputLimit(quantityInput, variant);
    }

    onPartsClick(event) {
      const open = event.target.closest('[data-map-part-open]');
      if (open) {
        this.openPartFromList(Number(open.dataset.mapPartOpen));
        return;
      }

      const add = event.target.closest('[data-map-part-add]');
      if (add) this.addPartToCart(Number(add.dataset.mapPartAdd), add);
    }

    onPartsPointerOver(event) {
      const row = event.target.closest('[data-map-part-row]');
      if (row && this.parts && this.parts.contains(row)) this.highlightAreaKey(row.dataset.mapAreaKey);
    }

    onPartsPointerOut(event) {
      const row = event.target.closest('[data-map-part-row]');
      if (!row || row.contains(event.relatedTarget)) return;
      this.clearListHotspotHighlight();
    }

    onPartsFocusIn(event) {
      const row = event.target.closest('[data-map-part-row]');
      if (row && this.parts && this.parts.contains(row)) this.highlightAreaKey(row.dataset.mapAreaKey);
    }

    onPartsFocusOut(event) {
      const row = event.target.closest('[data-map-part-row]');
      if (!row || row.contains(event.relatedTarget)) return;
      this.clearListHotspotHighlight();
    }

    highlightAreaKey(areaKey) {
      this.clearListHotspotHighlight();
      if (!areaKey) return;
      const hotspot = this.hotspotCache.get(areaKey);
      if (hotspot) hotspot.classList.add('is-list-highlight');
    }

    clearListHotspotHighlight() {
      this.querySelectorAll('.exploded-map__hotspot.is-list-highlight').forEach((item) => item.classList.remove('is-list-highlight'));
    }

    openPartFromList(index) {
      const row = this.partsData[index];
      if (!row) return;

      this.querySelectorAll('.exploded-map__hotspot.is-active').forEach((item) => item.classList.remove('is-active'));
      const hotspot = this.hotspotCache.get(row.areaKey);
      if (hotspot) hotspot.classList.add('is-active');

      this.currentProduct = null;
      this.currentVariant = null;
      this.currentChoices = [];
      this.panel.innerHTML = `<div class="exploded-map__panel-loading">${this.escape(this.labels.loading)}</div>`;
      this.openDialog();

      if (row.product) {
        this.showProduct(row.ref, row.product);
        return;
      }

      this.loadProductRef(row.ref)
        .then((product) => {
          row.product = product;
          row.variant = this.getInitialVariant(product, row.ref.variantId);
          row.sku = row.variant && row.variant.sku ? row.variant.sku : product && product.sku ? product.sku : row.sku;
          row.mpn = row.variant && row.variant.mpn ? row.variant.mpn : row.mpn;
          this.showProduct(row.ref, product);
        })
        .catch((error) => {
          console.warn('Exploded map list product lookup failed', {row: row, error: error});
          this.renderUnavailableArea(row.ref);
        });
    }

    addPartToCart(index, button) {
      const row = this.partsData[index];
      if (!row || !row.variant || button.disabled) return;

      const tr = button.closest('[data-map-part-row]');
      const quantityInput = tr ? tr.querySelector(`[data-map-part-quantity="${index}"]`) : null;
      const status = tr ? tr.querySelector('[data-map-part-status]') : null;
      const text = button.querySelector('[data-map-part-add-text]');
      const quantity = this.quantityForVariantInput(quantityInput, row.variant);
      if (quantity < 1) return;
      this.addVariantToCart(row.variant.id, quantity, button, status, text, this.labels.addToCart);
    }

    onPanelClick(event) {
      const choice = event.target.closest('[data-map-product-choice]');
      if (choice) {
        this.selectProductChoice(choice.dataset.mapProductChoice);
        return;
      }

      const quantityInput = this.panel.querySelector('[data-map-quantity]');
      if (event.target.closest('[data-map-decrease]') && quantityInput) quantityInput.value = String(Math.max(1, Number(quantityInput.value || 1) - 1));
      if (event.target.closest('[data-map-increase]') && quantityInput) quantityInput.value = String(Math.max(1, Number(quantityInput.value || 1) + 1));
      const add = event.target.closest('[data-map-add]');
      if (add) this.addToCart(add);
    }

    onDialogClick(event) {
      if (event.target.closest('[data-map-close]') || event.target === this.dialog) this.closeDialog();
    }

    addToCart(button) {
      if (!this.currentVariant || button.disabled) return;
      const quantityInput = this.panel.querySelector('[data-map-quantity]');
      const status = this.panel.querySelector('[data-map-status]');
      const text = this.panel.querySelector('[data-map-add-text]');
      const quantity = this.quantityForVariantInput(quantityInput, this.currentVariant);
      if (quantity < 1) return;
      this.addVariantToCart(this.currentVariant.id, quantity, button, status, text, this.labels.addToCart);
    }

    quantityForVariantInput(input, variant) {
      const requested = Math.max(1, Number(input ? input.value : 1) || 1);
      const remaining = this.remainingQuantityForVariant(variant);
      if (remaining === null) return requested;

      const quantity = Math.max(0, Math.min(requested, remaining));
      if (input && Number(input.value) !== quantity) input.value = String(Math.max(1, quantity));
      return quantity;
    }

    updateQuantityInputLimit(input, variant) {
      if (!input) return;

      const remaining = this.remainingQuantityForVariant(variant);
      if (remaining === null) {
        input.removeAttribute('max');
        return;
      }

      input.max = String(remaining);
      const current = Math.max(1, Number(input.value) || 1);
      if (remaining > 0 && current > remaining) input.value = String(remaining);
      if (remaining < 1) input.value = '1';
    }

    addVariantToCart(variantId, quantity, button, status, text, resetText) {
      const cartAddUrl = window.theme && window.theme.routes && window.theme.routes.cart_add_url ? window.theme.routes.cart_add_url : '/cart/add.js';

      button.disabled = true;
      button.classList.add('is-loading');
      if (status) {
        status.textContent = '';
        status.classList.remove('is-error');
      }

      fetch(cartAddUrl, {
        method: 'POST',
        headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({id: variantId, quantity: quantity}),
      })
        .then((response) => response.json().then((json) => {
          if (!response.ok || json.status) throw json;
          return json;
        }))
        .then((json) => this.syncVariantQuantityFromCart(variantId).catch(() => {
          const acceptedQuantity = this.quantityFromAddResponse(json);
          if (acceptedQuantity > 0) {
            this.setVariantAdded(variantId, acceptedQuantity);
          } else {
            this.markVariantAdded(variantId, quantity);
          }
        }))
        .then(() => {
          const isPartsListStatus = Boolean(status && status.hasAttribute('data-map-part-status'));
          if (text) text.textContent = this.labels.added;
          if (status && !isPartsListStatus) status.textContent = this.labels.added;
          document.dispatchEvent(new CustomEvent('theme:cart:refresh', {bubbles: true}));
          document.dispatchEvent(new CustomEvent('theme:cart:change', {bubbles: true}));

          if (isPartsListStatus) {
            button.classList.remove('is-loading');
            if (text) text.textContent = resetText || this.labels.addToCart;
            this.updateAddedState();
            return;
          }

          setTimeout(() => {
            button.disabled = false;
            button.classList.remove('is-loading');
            if (text) text.textContent = resetText || this.labels.addToCart;
            this.updateAddedState();
          }, 1400);
        })
        .catch((error) => {
          button.disabled = false;
          button.classList.remove('is-loading');
          if (status) {
            status.textContent = error && error.description ? error.description : this.labels.error;
            status.classList.add('is-error');
          }
        });
    }

    getCartJsonUrl() {
      if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
        return `${window.Shopify.routes.root.replace(/\/?$/, '/')}cart.js`;
      }

      return '/cart.js';
    }

    syncVariantQuantityFromCart(variantId) {
      const key = String(variantId || '');
      if (!key) return Promise.resolve(0);

      return fetch(this.getCartJsonUrl(), {headers: {Accept: 'application/json'}})
        .then((response) => {
          if (!response.ok) throw new Error('Cart could not be loaded');
          return response.json();
        })
        .then((cart) => {
          let actualQuantity = 0;
          const items = cart && Array.isArray(cart.items) ? cart.items : [];

          items.forEach((item) => {
            if (String(item.variant_id || '') === key) {
              actualQuantity += this.numberValue(item.quantity);
            }
          });

          this.setVariantAdded(key, actualQuantity);
          return actualQuantity;
        });
    }

    quantityFromAddResponse(json) {
      if (!json) return 0;

      if (Array.isArray(json.items)) {
        return json.items.reduce((total, item) => total + this.numberValue(item && item.quantity), 0);
      }

      return this.numberValue(json.quantity);
    }

    setVariantAdded(variantId, quantity) {
      const key = String(variantId || '');
      const actualQuantity = this.numberValue(quantity);
      if (!key) return;

      if (actualQuantity > 0) {
        this.addedVariants.set(key, actualQuantity);
      } else {
        this.addedVariants.delete(key);
      }

      this.updateAddedState();
    }

    canAddVariant(variant) {
      if (!variant || !variant.available) return false;
      const remaining = this.remainingQuantityForVariant(variant);
      return remaining === null || remaining > 0;
    }

    remainingQuantityForVariant(variant) {
      const limit = this.stockLimitForVariant(variant);
      if (limit === null) return null;

      const key = variant && variant.id ? String(variant.id) : '';
      const currentQuantity = key ? this.addedVariants.get(key) || 0 : 0;
      return Math.max(0, limit - currentQuantity);
    }

    stockLimitForVariant(variant) {
      if (!variant || variant.inventory_policy === 'continue' || !variant.inventory_management) return null;
      return Math.max(0, this.numberValue(variant.inventory_quantity));
    }

    markVariantAdded(variantId, quantity) {
      const key = String(variantId || '');
      if (!key) return;

      const currentQuantity = this.addedVariants.get(key) || 0;
      this.addedVariants.set(key, currentQuantity + quantity);
      this.updateAddedState();
    }

    updateAddedState() {
      const addedAreaKeys = new Set();
      let totalQuantity = 0;

      this.addedVariants.forEach((quantity) => {
        totalQuantity += quantity;
      });

      this.querySelectorAll('[data-map-part-row]').forEach((row) => {
        const variantId = row.dataset.mapVariantId;
        const quantity = variantId ? this.addedVariants.get(String(variantId)) || 0 : 0;
        const rowIndex = Number(row.dataset.mapPartRow);
        const rowData = Number.isFinite(rowIndex) ? this.partsData[rowIndex] : null;
        const rowVariant = rowData && rowData.variant ? rowData.variant : null;
        const status = row.querySelector('[data-map-part-status]');
        const badge = row.querySelector('[data-map-added-badge]');
        const quantityInput = row.querySelector('[data-map-part-quantity]');
        const addButton = row.querySelector('[data-map-part-add]');

        this.updateQuantityInputLimit(quantityInput, rowVariant);
        if (addButton && !addButton.classList.contains('is-loading')) {
          addButton.disabled = !this.canAddVariant(rowVariant);
        }

        row.classList.toggle('is-added', quantity > 0);
        if (quantity > 0) {
          addedAreaKeys.add(row.dataset.mapAreaKey);
          if (badge) {
            badge.hidden = false;
            badge.textContent = `${this.labels.added} x ${quantity}`;
          }
        } else {
          if (status && !status.classList.contains('is-error')) {
            status.textContent = '';
          }
          if (badge) {
            badge.hidden = true;
            badge.textContent = '';
          }
        }
      });

      this.querySelectorAll('.exploded-map__hotspot').forEach((hotspot) => {
        hotspot.classList.toggle('is-added', addedAreaKeys.has(hotspot.getAttribute('data-map-area-key')));
      });

      const cartStatus = this.querySelector('[data-map-cart-status]');
      const cartStatusText = this.querySelector('[data-map-cart-status-text]');
      if (cartStatus && cartStatusText) {
        cartStatus.hidden = totalQuantity < 1;
        cartStatusText.textContent = `${totalQuantity} ${this.labels.addedParts}`;
      }
    }

    getProductImage(product, variant) {
      if (variant && variant.featured_image && variant.featured_image.src) return variant.featured_image.src;
      if (product.featured_image) return product.featured_image;
      if (Array.isArray(product.images) && product.images.length) return product.images[0];
      return '';
    }

    renderSku(value) {
      const sku = typeof value === 'object' && value ? value.sku : value;
      if (!sku) return '';
      return `${this.escape(this.labels.sku)}: <span>${this.escape(sku)}</span>`;
    }

    renderMpn(variant) {
      if (!variant || !variant.mpn) return '';
      return `${this.escape(this.labels.partno)}: <span>${this.escape(variant.mpn)}</span>`;
    }

    getStockStatus(variant) {
      if (!variant) return {color: 'red', text: this.labels.catalogUnavailable || this.labels.unavailable};

      const radneStock = this.numberValue(variant.radne_stock_level);
      const supplierStock = this.numberValue(variant.supplier_stock_level);
      const incomingQuantity = this.numberValue(variant.incoming_quantity);
      const backInStockDate = String(variant.back_in_stock_date || '');

      if (!variant.available) {
        if (incomingQuantity > 0 && backInStockDate && this.isTodayOrFuture(backInStockDate)) {
          return {color: 'yellow', text: `${this.labels.stockIncoming || this.labels.inStock} ${backInStockDate}`.trim()};
        }
        if (incomingQuantity > 0) return {color: 'red', text: this.labels.stockNotInStock || this.labels.unavailable};
        if (variant.inventory_policy === 'continue') return {color: 'yellow', text: this.labels.stockOnRequest || this.labels.unavailable};
        if (this.isCatalogUnavailable(variant)) return {color: 'red', text: this.labels.catalogUnavailable || this.labels.unavailable};
        return {color: 'red', text: this.labels.stockNotInStock || this.labels.unavailable};
      }

      // Shopify inventory_quantity includes supplier locations. These two
      // metafields are the source of truth for where the stock is held.
      if (radneStock > 0) return {color: 'green', text: this.labels.stockInStock || this.labels.inStock};
      if (supplierStock > 0) return {color: 'green', text: this.labels.stockSupplier || this.labels.inStock};
      if (incomingQuantity > 0 && backInStockDate && this.isTodayOrFuture(backInStockDate)) {
        return {color: 'yellow', text: `${this.labels.stockIncoming || this.labels.inStock} ${backInStockDate}`.trim()};
      }
      if (incomingQuantity > 0) return {color: 'red', text: this.labels.stockNotInStock || this.labels.unavailable};
      if (variant.inventory_policy === 'continue') return {color: 'yellow', text: this.labels.stockOnRequest || this.labels.unavailable};
      return {color: 'red', text: this.labels.stockNotInStock || this.labels.unavailable};
    }

    isCatalogUnavailable(variant) {
      if (!variant) return true;
      if (variant.available) return false;

      const incomingQuantity = this.numberValue(variant.incoming_quantity);
      if (incomingQuantity > 0 || variant.inventory_policy === 'continue') return false;

      const stockSignals = [
        variant.radne_stock_level,
        variant.supplier_stock_level,
      ];

      return stockSignals.some((value) => this.numberValue(value) > 0);
    }

    isCatalogUnavailableRef(ref) {
      if (!ref) return false;
      if (ref.catalogUnavailable === true || ref.catalogUnavailable === 'true') return true;

      const handle = this.cleanProductHandle(ref.productHandle || ref.handle || ref.product_handle);
      const productId = this.idFromGid(ref.productId || ref.product_id);
      const variantId = this.idFromGid(ref.variantId || ref.variant_id);

      const rows = Array.isArray(this.partsData) ? this.partsData : [];
      return rows.some((row) => {
        if (!row || !row.catalogUnavailable) return false;
        const rowRef = row.ref || {};
        const rowHandle = this.cleanProductHandle(rowRef.productHandle || rowRef.handle || rowRef.product_handle);
        const rowProductId = this.idFromGid(rowRef.productId || rowRef.product_id);
        const rowVariantId = this.idFromGid(rowRef.variantId || rowRef.variant_id);

        if (variantId && rowVariantId && variantId === rowVariantId) return true;
        if (productId && rowProductId && productId === rowProductId) return true;
        return Boolean(handle && rowHandle && handle === rowHandle);
      });
    }

    renderStockStatus(status) {
      const state = status || {color: 'red', text: this.labels.stockNotInStock || this.labels.unavailable};
      const color = ['green', 'yellow', 'red'].includes(state.color) ? state.color : 'red';
      const icon = this.stockIcons && this.stockIcons[color] ? this.stockIcons[color] : '';
      const style = icon ? ` style="background-image:url('${this.escapeAttribute(icon)}');"` : '';
      return `
        <div class="stock-row exploded-map__stock-row">
          <span class="stock-icon stock-${this.escapeAttribute(color)}"${style}>${this.escape(state.text)}</span>
        </div>
      `;
    }

    numberValue(value) {
      if (value === null || typeof value === 'undefined' || value === '') return 0;
      const number = Number(value);
      return Number.isFinite(number) ? number : 0;
    }

    isTodayOrFuture(dateValue) {
      const date = new Date(dateValue);
      if (Number.isNaN(date.getTime())) return false;
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      date.setHours(0, 0, 0, 0);
      return date >= today;
    }

    renderDescription(product) {
      const description = this.stripHtml(product && product.description);
      if (!description) return '';

      return `
        <details class="exploded-map__description">
          <summary>
            <span class="exploded-map__description-preview">${this.escape(description)}</span>
            <span class="exploded-map__description-toggle exploded-map__description-more">${this.escape(this.labels.descriptionMore)}</span>
            <span class="exploded-map__description-toggle exploded-map__description-less">${this.escape(this.labels.descriptionLess)}</span>
          </summary>
          <div class="exploded-map__description-full">${this.escape(description)}</div>
        </details>
      `;
    }

    stripHtml(value) {
      return String(value || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
    }

    formatMoney(value) {
      if (window.theme && typeof window.theme.formatMoney === 'function') return window.theme.formatMoney(value, window.theme.moneyFormat);
      return String(value);
    }

    escape(value) {
      return String(value || '').replace(/[&<>"']/g, (character) => ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
      }[character]));
    }

    escapeAttribute(value) {
      return this.escape(value);
    }
  }

  if (!customElements.get('exploded-map')) {
    customElements.define('exploded-map', ExplodedMap);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["exploded-view-index"] && !Shopify.designMode) return;
  try {
    
  class ExplodedViewIndex extends HTMLElement {
    connectedCallback() {
      this.search = this.querySelector('[data-exploded-index-search]');
      this.filters = Array.from(this.querySelectorAll('[data-exploded-index-filter]'));
      this.cards = Array.from(this.querySelectorAll('[data-exploded-index-card]'));
      this.groups = Array.from(this.querySelectorAll('[data-exploded-index-group]'));
      this.subgroups = Array.from(this.querySelectorAll('[data-exploded-index-subgroup]'));
      this.empty = this.querySelector('[data-exploded-index-empty]');
      this.activeGroup = 'all';

      if (this.search) this.search.addEventListener('input', () => this.applyFilters());
      this.filters.forEach((button) => {
        button.addEventListener('click', () => {
          this.activeGroup = button.dataset.explodedIndexFilter || 'all';
          this.filters.forEach((item) => item.classList.toggle('is-active', item === button));
          this.applyFilters();
        });
      });
    }

    applyFilters() {
      const query = this.normalize(this.search ? this.search.value : '');
      let visibleCount = 0;

      this.cards.forEach((card) => {
        const matchesGroup = this.activeGroup === 'all' || card.dataset.group === this.activeGroup;
        const matchesSearch = !query || this.normalize(card.dataset.search || card.textContent).includes(query);
        const visible = matchesGroup && matchesSearch;
        card.classList.toggle('is-hidden', !visible);
        if (visible) visibleCount += 1;
      });

      this.groups.forEach((group) => {
        const hasVisibleCards = Boolean(group.querySelector('[data-exploded-index-card]:not(.is-hidden)'));
        group.classList.toggle('is-hidden', !hasVisibleCards);
      });

      this.subgroups.forEach((subgroup) => {
        const hasVisibleCards = Boolean(subgroup.querySelector('[data-exploded-index-card]:not(.is-hidden)'));
        subgroup.classList.toggle('is-hidden', !hasVisibleCards);
      });

      if (this.empty) this.empty.hidden = visibleCount > 0;
    }

    normalize(value) {
      return String(value || '').toLowerCase().trim();
    }
  }

  if (!customElements.get('exploded-view-index')) {
    customElements.define('exploded-view-index', ExplodedViewIndex);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-purchase"]) return;
  try {
    
  if (!customElements.get('sticky-purchase')) {
    customElements.define('sticky-purchase', class extends HTMLElement {
      async connectedCallback() {
        await customElements.whenDefined('product-info');
        if (!this.isConnected || this.product) return;
        this.product = document.querySelector('product-info[id^="MainProduct--"]');
        this.block = this.product?.querySelector('.product__block--buttons product-form');
        if (!this.block) return;
        this.summary = this.querySelector('.sticky-purchase__summary');
        this.block.prepend(this.summary);
        this.spacer = document.createElement('div');
        this.spacer.className = 'sticky-purchase__spacer';
        this.spacer.setAttribute('aria-hidden', 'true');
        this.block.before(this.spacer);
        this.abort = new AbortController();
        this.fixed = false;
        this.originalHeight = this.block.getBoundingClientRect().height;
        this.schedule = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
        };
        window.addEventListener('scroll', this.schedule, { passive: true, signal: this.abort.signal });
        window.addEventListener('resize', this.schedule, { passive: true, signal: this.abort.signal });
        this.product.addEventListener('change', this.schedule, { signal: this.abort.signal });
        this.summary.querySelector('button')?.addEventListener('click', () => this.editVariant(), { signal: this.abort.signal });
        this.observer = new MutationObserver(this.schedule);
        this.observer.observe(this.product, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'value', 'checked', 'class'] });
        this.resizeObserver = new ResizeObserver(this.schedule);
        this.resizeObserver.observe(this.block);
        if (this.dataset.view) {
          this.originalBuildUrl = this.product.buildRequestUrlWithParams;
          this.originalUpdateUrl = this.product.updateURL;
          const controller = this;
          this.buildUrl = function (...args) {
            const url = new URL(controller.originalBuildUrl.apply(this, args), location.origin);
            url.searchParams.set('view', controller.dataset.view);
            return url.pathname + url.search;
          };
          this.updateUrl = function (...args) {
            controller.originalUpdateUrl.apply(this, args);
            const url = new URL(location.href);
            url.searchParams.set('view', controller.dataset.view);
            history.replaceState(history.state, '', url.pathname + url.search + url.hash);
          };
          this.product.buildRequestUrlWithParams = this.buildUrl;
          this.product.updateURL = this.updateUrl;
        }
        this.update();
      }
      headerBottom() {
        const header = document.querySelector('[data-header-sticky]');
        const height = header ? document.querySelector('[data-header-height]')?.getBoundingClientRect().height || 0 : 0;
        return Math.max(0, height, header?.getBoundingClientRect().bottom || 0);
      }
      updateSelection() {
        const label = this.summary.querySelector('[data-sticky-selection]');
        if (!label) return;
        const picker = this.product.querySelector('variant-selects');
        this.bundle = this.product.querySelector('[data-rbrselector="volumeDiscount"]');
        const selectedBundle = this.bundle?.querySelector('input:checked')?.closest('[data-rbrselector="discountOptionV5"]');
        const bundleName = selectedBundle?.querySelector('[data-rbrselector="discountInfoV3Description"] > span')?.textContent.trim();
        const bundleDiscount = selectedBundle?.querySelector('[data-rbrselector="labelNormal"]')?.textContent.trim();
        const options = Array.from(picker?.querySelectorAll('[data-option-position]') || []).map(option => {
          const name = option.querySelector('.radio__legend__option-name, .select__label')?.textContent.trim();
          const value = option.querySelector('input:checked')?.value || option.querySelector('select')?.selectedOptions[0]?.textContent.trim() || option.querySelector('[data-selected-value]')?.textContent.trim();
          return value ? [name, value].filter(Boolean).join(': ') : '';
        }).filter(Boolean);
        const variantValue = options.join(' / ');
        const bundleValue = bundleName ? [bundleName, /\d/.test(bundleDiscount || '') ? bundleDiscount : ''].filter(Boolean).join(' · ') : '';
        const value = [variantValue, bundleValue].filter(Boolean).join(' · ');
        if (label.textContent !== value) label.textContent = value;
        const button = this.summary.querySelector('button');
        button.hidden = !value;
        button.setAttribute('aria-label', `${button.dataset.actionLabel}: ${value}`);
      }
      update() {
        this.updateSelection();
        if (!this.fixed) this.originalHeight = this.block.getBoundingClientRect().height;
        const shouldFix = this.spacer.getBoundingClientRect().top + this.originalHeight <= this.headerBottom();
        if (shouldFix !== this.fixed) {
          this.fixed = shouldFix;
          this.spacer.style.height = this.fixed ? `${this.originalHeight}px` : '0px';
          this.block.classList.toggle('sticky-purchase--fixed', this.fixed);
          this.summary.hidden = !this.fixed;
        }
        if (this.fixed) {
          document.documentElement.style.setProperty('--cart-bar-height', `${this.block.getBoundingClientRect().height}px`);
        } else {
          document.documentElement.style.removeProperty('--cart-bar-height');
        }
      }
      editVariant() {
        const picker = this.bundle || this.product.querySelector('variant-selects');
        if (!picker) return;
        this.fixed = false;
        this.block.classList.remove('sticky-purchase--fixed');
        this.summary.hidden = true;
        this.spacer.style.height = '0px';
        const focusTarget = picker.querySelector('input:checked') || picker.querySelector('select, button, input');
        focusTarget?.focus({ preventScroll: true });
        window.scrollTo({ top: window.scrollY + picker.getBoundingClientRect().top - this.headerBottom() - 20, behavior: 'instant' });
        this.update();
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.frame);
        this.block?.classList.remove('sticky-purchase--fixed');
        this.spacer?.remove();
        if (this.summary) { this.summary.hidden = true; this.append(this.summary); }
        if (this.product?.buildRequestUrlWithParams === this.buildUrl) this.product.buildRequestUrlWithParams = this.originalBuildUrl;
        if (this.product?.updateURL === this.updateUrl) this.product.updateURL = this.originalUpdateUrl;
        document.documentElement.style.removeProperty('--cart-bar-height');
        this.product = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
